import { createTheme, Theme } from '@mui/material/styles';

const typography = {
  fontFamily: '"Inter", sans-serif',
  h1: { fontFamily: '"Barlow Condensed", sans-serif' },
  h2: { fontFamily: '"Barlow Condensed", sans-serif' },
  h3: { fontFamily: '"Barlow Condensed", sans-serif' },
  h4: { fontFamily: '"Barlow Condensed", sans-serif' },
  h5: { fontFamily: '"Barlow Condensed", sans-serif' },
  h6: { fontFamily: '"Barlow Condensed", sans-serif' },
};

export const createAppTheme = (mode: 'dark' | 'light'): Theme =>
  createTheme({
    typography,
    palette: {
      mode,
      primary: { main: '#4CAF50' },
      ...(mode === 'dark' ? {
        background: { default: '#2B2B2B', paper: '#3D3D3D' },
        text: { primary: '#FFFFFF', secondary: '#A0A0A0' },
      } : {
        background: { default: '#F0F2F5', paper: '#FFFFFF' },
      }),
    },
    shape: { borderRadius: 8 },
  });

export const theme = createAppTheme('dark');
export default theme;
